import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

import * as Actions from './shipments.details.actions';

const initialState = {};

const deleteModalState = (newState, shipmentDetailModalId) => {
  if (newState.fulfillmentPlanToGuidMap) {
    // oxlint-disable-next-line no-param-reassign
    newState.fulfillmentPlanToGuidMap = Object.keys(newState.fulfillmentPlanToGuidMap).reduce((map, key) => {
      if (key === shipmentDetailModalId) {
        return map;
      }

      return map[key] === newState.fulfillmentPlanToGuidMap[key];
    }, {});
  }

  // oxlint-disable-next-line @typescript-eslint/no-dynamic-delete, no-param-reassign
  delete newState[shipmentDetailModalId];
  return newState;
};

export const shipmentDetails = (state = initialState, action) => {
  const { shipmentId, fulfillmentsUpdated, shipmentDetailModalId } = action;
  const shipmentState = state[shipmentDetailModalId];
  const fulfillments = get(state, `${shipmentDetailModalId}.shipment.fulfillments`, emptyArray);
  const modalState = state[shipmentDetailModalId];

  switch (action.type) {
    case Actions.SHIPMENT_DETAILS_MODAL_OPEN:
      return {
        ...state,
        fulfillmentPlanToGuidMap: {
          ...state.fulfillmentPlanToGuidMap,
          [shipmentId]: shipmentDetailModalId,
        },
        [shipmentDetailModalId]: {
          isLoading: true,
          fulfillmentPlanId: shipmentId,
          modalId: action.modalId,
        },
      };
    case Actions.LOAD_SHIPMENT_DETAILS:
      // SHIPMENT_DETAILS_MODAL_OPEN, but when
      // outside of a modal context
      return {
        ...state,
        fulfillmentPlanToGuidMap: {
          ...state.fulfillmentPlanToGuidMap,
          [shipmentId]: shipmentId,
        },
        [shipmentId]: {
          isLoading: true,
        },
      };
    case Actions.SHIPMENT_DETAILS_MODAL_CLOSED:
      return deleteModalState({ ...state }, shipmentDetailModalId);
    case Actions.GET_SHIPMENT_DETAILS_SUCCESS:
      return {
        ...state,
        [shipmentDetailModalId]: {
          ...modalState,
          isLoading: false,
          fulfillmentPlanId: action.fulfillmentPlanId,
        },
      };
    case Actions.SHIPMENT_NOTIFY_MARKETPLACE_REQUEST:
      return {
        ...state,
        [shipmentDetailModalId]: {
          ...shipmentState,
          isNotifyingMarketplace: true,
        },
      };
    case Actions.SHIPMENT_NOTIFY_MARKETPLACE_FAILURE:
      return {
        ...state,
        [shipmentDetailModalId]: {
          ...shipmentState,
          isNotifyingMarketplace: false,
        },
      };
    case Actions.SHIPMENT_NOTIFY_MARKETPLACE_SUCCESS: {
      fulfillments.forEach((fulfillment) => {
        const updatedFulfillment = fulfillmentsUpdated.find((element) => element.fulfillmentId === fulfillment.fulfillmentId);
        if (updatedFulfillment)
          // oxlint-disable-next-line no-param-reassign
          fulfillment.marketplaceNotification = updatedFulfillment.marketplaceNotification;
      });
      return {
        ...state,
        [shipmentDetailModalId]: {
          ...shipmentState,
          isNotifyingMarketplace: false,
        },
      };
    }
    case Actions.UPDATE_SHIPMENT:
      return {
        ...state,
        [action.shipmentDetailModalId]: {
          ...modalState,
          isLoading: false,
        },
      };
    case Actions.CLEAR_SHIPMENT_FROM_CUSTOMER_DETAILS_TRACKER:
      return {
        ...state,
        shipmentFromCustomerDetails: false,
      };
    default:
      return state;
  }
};

export { namespace } from './shipments.details.reducer.metadata';
